import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M18 19c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h10c.55 0 1 .45 1 1zM8 8c0-2.21 1.79-4 4-4s4 1.79 4 4v2H8zm9 2V8c0-2.76-2.24-5-5-5S7 5.24 7 8v2c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 13c-.55 0-1 .45-1 1 0 .37.21.67.5.85v2.65c0 .28.22.5.5.5s.5-.22.5-.5v-2.65c.29-.18.5-.48.5-.85 0-.55-.45-1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }